export const Days = [
  { value: "today", label: "Today" },
  { value: "last_week", label: "Last 7 Days" },
  { value: "last_month", label: "Last 30 Days" },
  { value: "custom", label: "Custom" },
];

export const genderData = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Other", label: "Other" },
];

export const stageMasterData = [
  { value: "medical_opinion", label: "Medical Opinion" },
  { value: "vil_requests", label: "VIL Requests" },
  { value: "pickup_details", label: "PickUp Details" },
  { value: "pre_intimation", label: "PreIntimation" },
];

// Add a helper function to get status options based on stage
export const getStatusOptionsForStage = (stageValue) => {
  return statusMasterData[stageValue] || [];
};

export const statusMasterData = {
  medical_opinion: [
    { value: "New Opinion Request", label: "New Opinion Request" },
    {
      value: "Additional Reports Requested",
      label: "Additional Reports Requested",
    },
    { value: "Query Sent To Doctor", label: "Query Sent To Doctor" },
    {
      value: "Opinion Received From Doctor",
      label: "Opinion Received From Doctor",
    },
    { value: "Opinion Sent To HCF", label: "Opinion Sent To HCF" },
    { value: "Opinion Rejected", label: "Opinion Rejected" },
  ],
  vil_requests: [
    { value: "Pending VIL", label: "Pending VIL" },
    { value: "Approval Pending", label: "Approval Pending" },
    { value: "Sent To HCF", label: "Sent To HCF" },
    { value: "Need Action", label: "Need Action" },
    { value: "Rejected", label: "Rejected" },
  ],
  pickup_details: [
    { value: "Not Requested", label: "Not Requested" },
    { value: "Requested", label: "Requested" },
    { value: "Pickup Details Provided", label: "Pickup Details Provided" },
    { value: "Rejected", label: "Rejected" },
  ],
  pre_intimation: [
    { value: "Not Provided", label: "Not Provided" },
    { value: "Provided", label: "Provided" },
  ],
};
